﻿import {IClientModel} from "../../Model/Client/ClientModel.js";
import {ResponseApi} from "../../Model/ResponseApi.js";
import {String} from "../../Tools/Misc.js"
import {OnClientAdd, OnClientUpdate} from "../../Delegates/ClientDelegate.js";
import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {NotificationHelper} from "../../Helper/NotificationHelper.js";


export class ClientUpsert {
        public static Upsert = async (payload: IClientModel) => {
            return JsonFetchJson.Put<ResponseApi<IClientModel>>("/client", payload)
                .then(response => {

                    if (response.Status != 200)
                    {
                        response.Errors.forEach(x => NotificationHelper.Instance.error(x.Message));
                        return;
                    }
                    
                    NotificationHelper.Instance.success("Le client a été enregistré.");
                    if (payload.Primarykey == String.GetEmptyGuid) {
                        OnClientAdd.Fire(response.Data);
                    } else {
                       OnClientUpdate.Fire(response.Data);
                    }
                    return response.Data;
                });
        }
    }
